import _matchRoutes from './matchRoutes';
export { _matchRoutes as matchRoutes };
import _renderRoutes from './renderRoutes';
export { _renderRoutes as renderRoutes };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-config/es/index.js
// module id = 928
// module chunks = 31